import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updatePayLaterEnabled } from "../actions/updatePayLaterEnabled";
import { useGlobalSnackbar } from "../../../context/SnackbarContext";
import { IPaypalMerchantInfo } from "../interfaces";

type PreviousQueriesData = [unknown[], IPaypalMerchantInfo | undefined][];

export const useUpdatePayLaterEnabled = () => {
  const { showSnackbar } = useGlobalSnackbar();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payLaterEnabled: boolean) => updatePayLaterEnabled(payLaterEnabled),
    onMutate: async (payLaterEnabled: boolean) => {
      await queryClient.cancelQueries({ queryKey: ["merchant-info"] });
      const previousQueriesData = queryClient.getQueriesData<IPaypalMerchantInfo>({ queryKey: ["merchant-info"] }) as PreviousQueriesData;
      queryClient.setQueriesData<IPaypalMerchantInfo>(
        { queryKey: ["merchant-info"] },
        (old) => (old ? { ...old, payLaterEnabled } : old),
      );
      return { previousQueriesData };
    },
    onSuccess: (_, payLaterEnabled) => {
      showSnackbar(
        payLaterEnabled ? "Pay Later enabled" : "Pay Later disabled",
        "success",
      );
    },
    onError: (error: Error, _, context: { previousQueriesData: PreviousQueriesData } | undefined) => {
      if (context?.previousQueriesData) {
        context.previousQueriesData.forEach(([queryKey, data]) => {
          queryClient.setQueryData(queryKey, data);
        });
      }
      showSnackbar(error.message, "error");
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["merchant-info"] });
    },
  });
};
